import { Kicker, Reveal } from "../components/Reveal";
import { IMAGES } from "../lib/data";

const CHAPTERS = [
  {
    title: "The Provider",
    body: "Nichole Olsen is a licensed Nurse Practitioner serving Northern Utah with a rare blend of clinical precision and an artist's eye. From injectables to hormone therapy to medical cannabis certification, every plan begins with listening.",
  },
  {
    title: "The Philosophy",
    body: "Natural results. Honest recommendations. Conservative dosing. Nichole believes the best work is the kind nobody can put their finger on — you, rested and confident.",
  },
  {
    title: "The Experience",
    body: "A private, unhurried suite inside Salon 406 in North Ogden. No rushed chairs, no upsells — just one-on-one time with your provider and a plan built around you.",
  },
];

export default function AboutSection() {
  return (
    <section id="about" data-testid="about-section" className="bg-ivory py-20 sm:py-28">
      <div className="mx-auto grid max-w-7xl items-start gap-16 px-6 sm:px-8 lg:grid-cols-2">
        <Reveal className="lg:sticky lg:top-28">
          <div className="mx-auto max-w-md overflow-hidden rounded-lg">
            <img
              src={IMAGES.provider}
              alt="Nichole Olsen, Nurse Practitioner"
              className="h-[520px] w-full object-cover"
            />
          </div>
        </Reveal>

        <div>
          <Reveal>
            <Kicker>Meet Your Provider</Kicker>
            <h2 className="mt-4 font-serif text-4xl font-medium leading-tight tracking-tight text-forest sm:text-5xl">
              Care that begins with a conversation
            </h2>
          </Reveal>

          <div className="mt-12 space-y-10">
            {CHAPTERS.map((ch, i) => (
              <Reveal key={ch.title} delay={i * 0.05}>
                <h3 className="font-serif text-2xl font-medium text-forest">{ch.title}</h3>
                <p className="mt-3 max-w-lg text-sm leading-relaxed text-moss sm:text-base">{ch.body}</p>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.1}>
            <div className="mt-12 border-t border-linen pt-8">
              <p className="font-serif text-2xl font-medium text-forest">Nichole Olsen</p>
              <p className="mt-1 text-sm text-moss">Nurse Practitioner &middot; North Ogden, Utah</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
